<article class="settings-container">
  <div class="settings">
    <app-settings-side-menu></app-settings-side-menu>

    <div class="sub-domain"><router-outlet></router-outlet></div>
  </div>
</article>
